import React from "react";
import PracticeCard from "../PracticeCard/PracticeCard";
import "./PracticeList.css";

const PracticeList = ({ chapters, web_load_url }) => {
  if (
    chapters?.length === 0 ||
    !chapters ||
    chapters[0]?.chapters?.length === 0
  ) {
    return (
      <div className="practice-list-wrapper">
        <div className="practice-list-container">
          <p style={{ textAlign: "center", padding: "20px", color: "#6b7280" }}>
            Coming Soon...
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="practice-list-wrapper">
      <div className="practice-list-container">
        <div className="practice-grid">
          {chapters[0]?.chapters?.map((chap) => (
            <PracticeCard
              key={chap.chapter_id}
              chap={chap}
              web_load_url={web_load_url}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default PracticeList;
